/** @jsx jsx **/
import { jsx } from '@emotion/react';
import { Button } from "../../_shared/button";
import React from 'react';
import './a1-registration.css'

export interface A1InstallationConfirmationProps {
  confirm: () => void;
  cancel: () => void;
  error: string;
};

export const A1InstallationConfirmation = (props: A1InstallationConfirmationProps) => {
  if (props.error) {
    return <div>{props.error}</div>
  }
  return (<div className='a1-confirmation-container'>
    <div className='a1-purple-subheader'>Confirm Installation</div>
    <div className='a1-confirm-box'>
      <div className='a1-confirm-body'>Are you sure you want to confirm your installation?</div>
      <div className='a1-confirm-buttons'>
        <Button outline onClick={props.cancel} title='Cancel' />
        <Button onClick={props.confirm} title="Confirm" />
      </div>
    </div>
  </div>);
};